var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',{attrs:{"loading":_vm.LoadingPage}},[(!_vm.IsReady)?_c('LoadingWait',{attrs:{"text":`Loading Partner Information`}}):_c('PartnerCard',{attrs:{"partner":this.partner}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }